






























import {Component, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {CustomerStore} from "@/modules/customers/store";
import debounce from "lodash/debounce";
import {listCustomer} from "@/modules/customers/services";
import {CustomerType} from "@/enums/type/customertype";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import TableToExcel from "@linways/table-to-excel";
import CustomerExcel from "@/modules/customers/List/components/Excel.vue";

@Component({
    name: "CustomerSearch",
    components: {CustomerExcel, PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    form = {
        search: "",
        status: undefined,
        postOfficeRowGuid: undefined
    };
    isExporting = false;
    dataSourceExcel = [] as any;

    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        CustomerStore.updateCustomerParams(val);
        CustomerStore.listCustomer({ ...val, page: 1 })
    }, 500);

    async exportExcel() {
        try {
            this.dataSourceExcel = await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-customer"), {
                    name: `Khách hàng.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            const { data } = await listCustomer({
                ...CustomerStore.params,
                type: CustomerType.Customer,
                page: 1,
                limit: 2000000
            });
            return data.datas;
        } catch (e) {
        }
    }
}
